/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .main-container[_ngcontent-%COMP%]{width:100%;display:-ms-flexbox;display:flex}[_nghost-%COMP%]   input[_ngcontent-%COMP%]{-ms-flex-positive:1;flex-grow:1}[_nghost-%COMP%]   .clear-button[_ngcontent-%COMP%]{-ms-flex-negative:0;flex-shrink:0;display:-ms-inline-flexbox;display:inline-flex}"];
export { styles as styles };
